import {getFunctions, httpsCallable} from 'firebase/functions';
import {app} from '../firebase.js';
export const JANAKPURI_HOTEL_ID='Hotel Dev Palace - Jankpuri';
let claimId='';
export function setJanakpuriClaim(value){claimId=value||'';}
export function getJanakpuriClaim(){return claimId;}
function pack(value){
 if(value && typeof value.toMillis==='function' && Number.isFinite(value.seconds))return {__jpTimestamp:[value.seconds,value.nanoseconds]};
 if(value instanceof Date)return {__jpTimestamp:[Math.floor(value.getTime()/1000),(value.getTime()%1000)*1000000]};
 if(Array.isArray(value))return value.map(pack);
 if(value && typeof value==='object')return Object.fromEntries(Object.entries(value).filter(([,v])=>v!==undefined).map(([k,v])=>[k,pack(v)]));
 return value;
}
export async function janakpuriCall(action,data={}){
 const response=await httpsCallable(getFunctions(app,'asia-south1'),'janakpuriBookings')(pack({action,...data}));
 return response.data;
}
export const stayProjection=s=>({hotelId:s.hotelId||'',room:s.room||'',checkInAt:s.checkInAt||'',expectedCheckOutAt:s.expectedCheckOutAt||'',status:s.status||'',checkedOut:s.checkedOut===true,checkoutCompleted:s.checkoutCompleted===true,janakpuriBookingId:s.janakpuriBookingId||''});
